<template>
  <div>
    <v-row>
      <v-col style="max-width: 350px">
        <!-- Illustration data -->
        <h4 class="mb-2">挿絵データ</h4>
        <v-img
          max-height="280"
          height="200"
          max-width="270"
          class="mb-2"
          v-if="image"
          :lazy-src="image.fileUrl"
          :src="image.fileUrl"
          aspect-ratio="1.7"
          contain
        />
        <v-img
          max-height="280"
          height="200"
          max-width="270"
          v-else
          class="mb-2"
          lazy-src="@/assets/defaultImage.jpg"
          src="@/assets/defaultImage.jpg"
          aspect-ratio="1.7"
          contain
        />
        <div class="d-flex">
          <v-spacer></v-spacer>
          <base-upload type="image" v-model="image">
            <div slot="activator">
              <v-btn
                color="primary"
                small
                :loading="loadingImage"
                :disabled="loadingImage"
                >ファイル選択</v-btn
              >
            </div>
          </base-upload>
        </div>
        <!-- Listen all -->
        <h4 class="my-2">会話全体の音声データ</h4>
        <audio :key="keyAudio" controls style="max-width: 270px" class="mb-2">
          <source
            :src="audio && audio.fileUrl ? audio.fileUrl : null"
            type="audio/mp3"
          />
          Your browser does not support the audio element.
        </audio>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <base-upload type="audio" v-model="audio">
            <div slot="activator">
              <v-btn
                color="primary"
                small
                :loading="loadingAudio"
                :disabled="loadingAudio"
                >ファイル選択</v-btn
              >
            </div>
          </base-upload>
        </div>
        <!-- Vocabulary -->
        <VocabularyList />
      </v-col>
      <v-col>
        <ListActor />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  getDetailConversation,
  updateConversation,
} from "@/api/Conversation.api";
import ListActor from "@/views/listSection/Skit/acTor/ListActor.vue";
import uploadFile from "@/utils/uploadFile";
import VocabularyList from "@/views/listSection/Skit/vocabulary/VocabularyList";
export default {
  components: {
    ListActor,
    VocabularyList,
  },
  data() {
    return {
      detailsConversation: {},
      listConversation: [],
      image: null,
      audio: null,
      keyAudio: 0,
      loadingAudio: false,
      loadingImage: false,
    };
  },
  watch: {
    image: async function (val) {
      if (val !== null && val.file) {
        this.loadingImage = true;
        await uploadFile(this.image.file, "image").then(async (e) => {
          let params = {
            image: e,
            id: this.$route.params.skit,
            section_id: this.$route.params.section,
          };
          await updateConversation(params);
        });
        this.loadingImage = false;
      }
    },
    audio: async function (val) {
      if (val !== null && val.file) {
        this.loadingAudio = true;
        await uploadFile(this.audio.file, "audio").then(async (e) => {
          let params = {
            full_audio: e,
            id: this.$route.params.skit,
            section_id: this.$route.params.section,
          };
          await updateConversation(params);
          this.keyAudio++;
        });
        this.loadingAudio = false;
      }
    },
  },
  async created() {
    await this.handleGetDetailConversation();
  },
  methods: {
    async handleGetDetailConversation() {
      let params = {
        keyword: "",
        id: this.$route.params.skit,
        section_id: this.$route.params.section,
      };
      await getDetailConversation(params)
        .then(({ result }) => {
          this.detailsConversation = result;
          if (result.image_url) {
            this.image = {
              fileUrl: result.image_url,
            };
          }
          if (result.full_audio_url) {
            this.audio = {
              fileUrl: result.full_audio_url,
            };
            this.keyAudio++;
          }
          console.log("this.audio: ", this.audio);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
